import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { TablePagination } from '../../../../../../components/table'
import { useRESTapi } from '../../../../../../hooks/rest_API'
import { BinItem, Rack, BinItemKeys, Store, pagination } from '../../../../../../types'
import { AddBinModal } from './components/addmodal'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/src/components/ui/table'
import { ButtonIcon } from '@/src/components/buttons/buttonIcon'
import { Pencil, Trash } from 'lucide-react'
import { Button } from '@/src/components/ui/button'
import { DeleteModal } from './components/deleteModal'
import { SkeletonTableAdmin } from '@/src/pages/admin/components/skeltonTable'
import { ImportModal } from './components/importModal'



export function BinDetails() {
  const {rackId} = useParams()
  const [bin, set_bin] = useState<(BinItem & { page_number: number, delete: any, edit: any })[]>([])
  const [mode, set_mode] = useState<'edit' | 'add'>('add')
  const api = useRESTapi()
  const [update, setUpdate] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedEmployeeId, set_selected_product] = useState<string>()
  const [page_selected, set_page_selected] = useState<number>(1)
  const [products_total, set_bin_total] = useState<number>(1)
  const [per_page, set_per_page] = useState<number>(30)
  const [isRackLoading, setisRackLoading] = useState(false)
  const [showDeleteModal, setshowDeleteModal] = useState(false)
  const navigate = useNavigate()
  const [isDeleteoading, setIsDeleteLoading] = useState(false)
  const { warehouseId, storeId } = useParams()
  const [showImportModal, setShowImportModal] = useState(false)

  const header: {
    label: BinItemKeys | string,
    name: string
  }[] = [
      {
        label: 'page_number',
        name: "No"
      },
      {
        label: BinItemKeys.I08_Name,
        name: "name"
      },
      {
        label: BinItemKeys.I08_Capacity,
        name: "Capacity"
      },
      {
        label: 'edit',
        name: ''
      },
      {
        label: 'delete',
        name: ''
      },
    ]

  const updateUi = () => {
    setUpdate(!update)
  }

  async function delete_bin(id: number | string) {

    setIsDeleteLoading(true)
    try {
      const res = await api.Delete<{ success: boolean, data: Store[], message: string }>({
        url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/bin/${id}`,
        mode: 'admin'
      })
      updateUi();
      if (res.data.success) {
        alert(res.data.message)
        setshowDeleteModal(false)
      } else {
        alert(res.data?.message || 'somthing went wrong...')
      }
      
      
    } catch (error) {
      console.log(error)
    }
    setIsDeleteLoading(false)

  }

  function clickEditButton(id: string) {
    set_selected_product(id)
    setShowModal(true)
    set_mode('edit')
  }
  function open_add_modal() {
    set_selected_product(undefined)
    setShowModal(true)
    set_mode('add')
  }

  useEffect(
    () => {

      const initData = async () => {

        setisRackLoading(true)
        try {
          const res = await api.get<{ success: boolean, data: { data: (BinItem & { page_number: number, delete: any, edit: any })[] } & pagination }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/bin`,
            mode: 'admin',
            params: {
              perPage: per_page,
              page: page_selected,
              rackID:rackId
            }
          })

          if (res.data.success === true) {
            // console.log(res.data)
            set_bin(res.data.data.data.map(
              (item, index) => {
                item.page_number = ((page_selected - 1) * per_page) + (index + 1)
                item.delete = <ButtonIcon icon={<Trash className="h-4 w-4" />} onClick={() => { set_selected_product(String(item.I08_Bin_id!)); setshowDeleteModal(true) }}></ButtonIcon>
                item.edit = <ButtonIcon icon={<Pencil className="h-4 w-4" />} onClick={() => clickEditButton(String(item.I08_Bin_id))}></ButtonIcon>
                return item;
              }
            ))
            set_bin_total(res.data.data.total)
            setisRackLoading(false)
          }
        } catch (error) {

        }

      }

      initData()

    }, [update]
  )

  return (
    <div className='  w-full h-full flex flex-col items-center  overflow-auto py-10 gap-2 '>
      <AddBinModal
        id={selectedEmployeeId}
        show={showModal}
        closeModal={() => setShowModal(false)}
        updateUi={updateUi}
        mode={mode}
        setShow={setShowModal}
      />
      <DeleteModal
        show={showDeleteModal}
        setShow={setshowDeleteModal}
        onDelete={async () => {
          await delete_bin(selectedEmployeeId!);
        }}
        isDeleteing={isDeleteoading}
      />
      <ImportModal
        refetch={updateUi}
        show={showImportModal}
        setShow={setShowImportModal}
        rackId={Number(rackId)}
      />
      <div className=' flex w-full font-bold'>
        <Link to={'../../../'}>warehouse/</Link>
        <Link to={'../../'}>store/</Link>
        <Link to={'../'}>rack/</Link>
        <div>bin</div>
      </div>
      <div className=' p-2 text-2xl font-bold'>Bin List</div>
      <div className=' w-full flex justify-end gap-2' >
        <Button onClick={()=>setShowImportModal(true)} className=' '>Import</Button>
        <Button onClick={open_add_modal} className=' '>Add Bin</Button>
      </div>
      <div className='  overflow-auto  w-full border rounded-md'>
        {
          isRackLoading ?
            <SkeletonTableAdmin />
            :
            <Table >
              <TableHeader >
                <TableRow>
                  {
                    header.map(
                      (header, index) => <TableHead key={index}>{header.name}</TableHead>
                    )
                  }
                </TableRow>
              </TableHeader>
              <TableBody>
                {
                  bin.length === 0
                    ?
                    'No data'
                    :
                    bin.map(
                      (row:any, index) => (
                        <TableRow key={index}  >
                          {
                            header.map(
                              (header, index) => <TableCell key={index}>{row[header.label]}</TableCell>
                            )
                          }
                        </TableRow>
                      )
                    )

                }
              </TableBody>
            </Table>
        }
      </div>
      <div>
        <TablePagination totalRows={products_total} rowsPerPage={per_page} onClickIndex={(e) => { set_page_selected(e); updateUi() }} selectedPage={page_selected} />
      </div>
    </div>
  )
}
